/**
 * Notifications + provider self-service API client.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const h = (getAuthHeaders) => ({ headers: getAuthHeaders() });

export const listNotifications = async (getAuthHeaders, opts = {}) => {
  const qs = new URLSearchParams();
  if (opts.unread) qs.set('unread', 'true');
  if (opts.limit) qs.set('limit', String(opts.limit));
  return (await axios.get(`${API}/notifications?${qs}`, h(getAuthHeaders))).data;
};

export const markRead = async (getAuthHeaders, id) =>
  (await axios.post(`${API}/notifications/${id}/read`, {}, h(getAuthHeaders))).data;

export const markAllRead = async (getAuthHeaders) =>
  (await axios.post(`${API}/notifications/read_all`, {}, h(getAuthHeaders))).data;

export const deleteNotification = async (getAuthHeaders, id) =>
  (await axios.delete(`${API}/notifications/${id}`, h(getAuthHeaders))).data;

// Provider self-service
export const getProviderMe = async (getAuthHeaders) =>
  (await axios.get(`${API}/providers/me`, h(getAuthHeaders))).data;

export const editProviderMe = async (getAuthHeaders, patch) =>
  (await axios.patch(`${API}/providers/me`, patch, h(getAuthHeaders))).data;

export const changeProviderPassword = async (getAuthHeaders, current_password, new_password) =>
  (await axios.post(`${API}/providers/me/password`, { current_password, new_password }, h(getAuthHeaders))).data;

// Provider payment methods (self-service)
export const listMyPaymentMethods = async (getAuthHeaders) =>
  (await axios.get(`${API}/providers/me/payment-methods`, h(getAuthHeaders))).data;

export const createMyPaymentMethod = async (getAuthHeaders, payload) =>
  (await axios.post(`${API}/providers/me/payment-methods`, payload, h(getAuthHeaders))).data;

export const updateMyPaymentMethod = async (getAuthHeaders, id, patch) =>
  (await axios.patch(`${API}/providers/me/payment-methods/${id}`, patch, h(getAuthHeaders))).data;

export const archiveMyPaymentMethod = async (getAuthHeaders, id) =>
  (await axios.delete(`${API}/providers/me/payment-methods/${id}`, h(getAuthHeaders))).data;

// Catalog readers
export const listAvailablePaymentMethods = async (getAuthHeaders, params = {}) => {
  const qs = new URLSearchParams();
  if (params.country)  qs.set('country', params.country);
  if (params.currency) qs.set('currency', params.currency);
  if (params.op_type)  qs.set('op_type', params.op_type);
  return (await axios.get(`${API}/payment-methods/available?${qs}`, h(getAuthHeaders))).data;
};

export const adminListPaymentMethods = async (getAuthHeaders, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => v && qs.set(k, v));
  return (await axios.get(`${API}/admin/payment-methods?${qs}`, h(getAuthHeaders))).data;
};
